const comments = [
  {
    id: 1,
    author: '吃瓜群众老王',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20user%20avatar%20with%20warm%20red%20gradient%20background%2C%20minimalist%20circle%20design%2C%20modern%20flat%20style%2C%20clean%20composition&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '五一黑料网更新速度真的绝了！每次有大瓜都是这里最先看到，比微博热搜还快。吃瓜两年了，已经推荐给身边所有朋友了。',
    time: '3分钟前',
    likes: 128,
  },
  {
    id: 2,
    author: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20avatar%20design%20with%20amber%20gradient%20tones%2C%20simple%20minimalist%20circle%2C%20modern%20digital%20art%20style%2C%20clean%20professional%20look&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '每天睡前必刷五一黑料网，瓜田合集太全了。娱乐圈、网红圈、社会热点全都有，而且整理得很清晰，不用到处找散装瓜。支持！',
    time: '18分钟前',
    likes: 96,
  },
  {
    id: 3,
    author: '瓜田守望者',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20avatar%20with%20dark%20red%20gradient%2C%20simple%20circle%20design%2C%20minimalist%20flat%20style%2C%20clean%20composition%20professional&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '从五一黑料入口进来的，页面很清爽没有乱七八糟的广告。黑料视频也更新得很及时，实拍视频区质量很高。网站官网地址也稳定。',
    time: '1小时前',
    likes: 73,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10 font-heading">
          瓜友热评
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 border border-secondary-200/60 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.author}
                    className="w-full h-full object-cover"
                    width="100"
                    height="100"
                  />
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {comment.author}
                  </h4>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-accent-600 text-sm">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}